const Person = ({ width }) => {
    return (
        <div className={`person-icon ${width}`}>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 132.43 193.86">
              <g>
                <path d="M66.21 67.95c-18.74 0-33.98-15.24-33.98-33.98S47.48 0 66.21 0s33.98 15.24 33.98 33.98-15.24 33.98-33.98 33.98zm0-55.27c-11.74 0-21.29 9.55-21.29 21.3s9.55 21.29 21.29 21.29S87.5 45.72 87.5 33.98s-9.55-21.3-21.29-21.3zM132.43 193.86H0v-38.53c0-33.99 27.65-61.64 61.64-61.64h9.15c33.99 0 61.64 27.65 61.64 61.64v38.53zM12.68 181.18h107.06v-25.84c0-27-21.96-48.96-48.96-48.96h-9.15c-27 0-48.96 21.96-48.96 48.96v25.84z"></path>
              </g>
            </svg>
        </div>
    )
}

export default Person
